/**
 * @description: 账单消费明细报表
 * @author: lyr
*/
<template>
    <div class="bill-consume-detail-report">
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable  placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢类型">
                    <el-select v-model="list_form.room_type" filterable  placeholder="请选择包厢类型">
                        <el-option v-for="item in room_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢号">
                    <el-select v-model="list_form.room_id" filterable clearable placeholder="请选择包厢" :disabled="list_form.shop_id==''">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预订人">
                    <el-input v-model="list_form.book_admin_name" clearable placeholder="请输入预订人"></el-input>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-input v-model="list_form.goods_type_str" readonly clearable placeholder="请选择商品类型" @click.native="openGoodsTypePop"></el-input>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="list_form.goods_name" clearable placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <div class="total-row">
                <div class="item">折后总额合计：{{actual_total}}</div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="list_table">
                <el-table-column :prop="item.prop" :label="item.label" v-for="item in column_arr"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
        <!-- 商品类型选择 -->
        <div class="goods-type-pop ele-hide" ref="goods_type_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllGType" @change="handleCheckAllGTypeChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.goods_type" @change="handleCheckGTypeChange">
                    <el-checkbox v-for="item in goods_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'bill-consume-detail-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_list: [],
                room_type_list: [],
                goods_type_list: [],
                list_form: {
                    start_date: '',
                    end_date: '',
                    shop_id: '',
                    room_type: '0', // 包厢类型 0全部
                    room_id: '0',
                    book_admin_name: '',
                    goods_type: [],
                    goods_type_str: '',
                    goods_name: '',
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                actual_total: 0, // 折后总额
                column_arr: [],
                checkAllGType: false,
            }
        },
        mounted: function() {
            // 日期
            this.list_form.start_date = moment().subtract(1, 'day').format('YYYY-MM-DD 08:00');
            this.list_form.end_date = moment().format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getRoom(this.list_form.shop_id)
                this.getRoomType(this.list_form.shop_id)
                this.getGoodsType()
                this.getList(1);
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').toDate(),
                    endDate: moment().toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_date = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_date = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢类型
            getRoomType: function(shop_id) {
                const _this = this;
                Vue.axios.post('PublicData/api_getRoomType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_type_list = res.data.response.result.data;
                        _this.room_type_list.unshift({
                            id: '0',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getAllRoom', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_list = res.data.response.result;
                        _this.room_list.unshift({
                            id: '0',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getAllGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Report/BillSaleInfosList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_date,
                            "end_date": _this.list_form.end_date,
							"shop_id": _this.list_form.shop_id,
                            "room_id": _this.list_form.room_id,
                            "room_type": _this.list_form.room_type, // 包厢类型 0全部
                            "book_admin_name": _this.list_form.book_admin_name, 
                            "goods_type": _this.list_form.goods_type,
                            "goods_name": _this.list_form.goods_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total)
                            _this.actual_total = res.data.response.result.actual_total
                            _this.column_arr = []
                            let column_arr = res.data.response.result.column_arr
                            for(let i in column_arr){
                                _this.column_arr.push({
                                    'prop': i,
                                    'label': column_arr[i]
                                })
                            }
						}
						_this.list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeShop(val) {
                this.list_form.shop_id = val
                if (!!val) {
                    this.list_form.room_id = '0'
                    this.list_form.room_type = '0'
                 
                    this.getRoom(val)
                    this.getRoomType(val)
                }
            },

            // 打开商品类型选择弹窗
            openGoodsTypePop() {
                let _this = this
                let c_goods_type = _this.list_form.goods_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择商品类型', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.goods_type_pop),
                    cancel: function() {
                        _this.list_form.goods_type = c_goods_type
                    }
                }, function() {
                    let arr = []
                    if (_this.list_form.goods_type.length > 0) {
                        _this.list_form.goods_type.forEach(item => {
                            _this.goods_type_list.forEach(k => {
                                if (k.id == item) {
                                    arr.push(k.name)
                                }
                            })
                        })
                        _this.list_form.goods_type_str = arr.join(",")
                    }else {
                        _this.list_form.goods_type_str = ''
                    }
                    layer.closeAll()
                }, function() {
                    _this.list_form.goods_type = c_goods_type
                    layer.closeAll()
                });
            },

            // 商品类型全选
            handleCheckAllGTypeChange(val) {
                this.list_form.goods_type = []
                this.checkAllGType = val
                if (val) {
                    this.goods_type_list.forEach(item => {
                        this.list_form.goods_type.push(item.id)
                    })
                }
            },

            // 选择商品类型
            handleCheckGTypeChange(val) {
                this.checkAllGType = val.length === this.goods_type_list.length
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },

            listExport: function() {
                window.location.href = Vue.ctUrl + "Report/BillSaleInfosExport" +
                    "?start_date=" + this.list_form.start_date +
                    "&end_date=" + this.list_form.end_date +
                    "&shop_id=" + this.list_form.shop_id +
                    "&room_id=" + this.list_form.room_id +
                    "&room_type=" + this.list_form.room_type +
                    "&book_admin_name=" + this.list_form.book_admin_name +
                    "&goods_type=" + this.list_form.goods_type +
                    "&goods_name=" + this.list_form.goods_name;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .total-row {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item {
            margin-right: 50px;
        }
    }

    .goods-type-pop {
        .el-checkbox {
            width: 100px;
        }
    }
</style>